<template>
  <div class="row search-card">
    <h1 class="--bigger --white mx-2 w-100 text-center text-uppercase">
      {{ $t('hero.search-offers.title', 'Job offers') }}
    </h1>
    <div class="row search-inputs">
      <div class="col-12 col-xl-6">
        {{ $t('hero.search-offers.filters.keyword.label', 'Look for offers by') }}
        <div>
          <input
            v-model="search.keyword"
            class="input"
            :placeholder="$t('hero.search-offers.filters.keyword.placeholder', 'Position, company or a keyword')"
            @keyup.enter="doSearch"
          >
        </div>
      </div>
      <div class="col-12 col-xl-4">
        {{ $t('hero.search-offers.filters.province.label', 'in') }}
        <div>
          <b-form-select
            v-model="provinceSelected"
            :options="provinceOptions"
          />
        </div>
      </div>
      <div class="col-12 col-xl-2">
        <br>
        <b-button
          variant="info"
          class="search-button"
          @click="doSearch"
        >
          {{ $t('hero.search-offers.search', 'Search') }}
        </b-button>
      </div>
      <div class="container mt-4">
        <h3>
          {{ $t('hero.search-offers.view-offers.pretext', 'or') }}
          <router-link
            :to="{ name: 'search-offers' }"
            class="view-all-btn"
          >
            {{ $t('hero.search-offers.view-offers.link', 'view all offers') }}
          </router-link>
        </h3>
      </div>
    </div>
  </div>
</template>

<script>
import provinces from '@/assets/data/provinces';

export default {
  data() {
    return {
      search: {
        keyword: "",
        place: ""
      },
      provinceSelected: "Toda España", // HARDCODED
    }
  },
  computed: {
    provinceOptions() {
        let provincesList = provinces();
        provincesList.shift();
        provincesList = [
          { value: "El extranjero", text: this.$t('generic.abroad', 'Abroad') },
          { value: "Toda España", text: this.$t('generic.all-spain', 'All Spain') },
          { value: "-", text: "-----------------", disabled: true },
          ...provincesList
        ];
        return provincesList;
    }
  },
  methods: {
    doSearch() {
      let queryParams = { keyword: this.search.keyword };

      if (this.provinceSelected === "Toda España" || this.provinceSelected === "El extranjero") {
        queryParams.provinces = this.provinceSelected;
      } else {
        queryParams.provinces = [this.provinceSelected];
      }

      this.$router.replace({ name: 'search-offers', query: { ...queryParams } });
    }
  }
}
</script>

<style lang="scss" scoped>
  .search-card {
    background: rgba(0, 139, 181, 0.5);
    border-radius: 30px;
    color: #fff;
    padding: 5rem 2rem 2rem;

    .input {
      width: 100%;
      border-radius: 4px;
      padding: 5px;
      border: 1px solid #c7c7c7;

      &.select {
        padding: 7px;
      }
    }

    .search-button {
      background: #ff6340;
      border: 1px solid #ff6340;
      font-weight: 600;
      font-size: 0.9rem;

      @media screen and (max-width: 1199px) {
        width: 100%;
      }

      &:hover {
        background: #ff4e27;
      }
    }
  }

  .view-all-btn {
    color: #fff !important;
    font-style: italic;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
      color: #ddd !important;
    }
  }

  @media screen and (min-width: 768px){
    .search-inputs {
      width: 100%;
    }
  }
</style>

